const MOSCOW_ID = -1;
const MOSCOW_AREA_ID = 4593;

const SPB_ID = -2;
const LO_ID = 4588;

export const MOSCOW_AND_MO_IDS = [MOSCOW_ID, MOSCOW_AREA_ID];
export const SPB_AND_LO_IDS = [SPB_ID, LO_ID];
